import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { DateHelpers, EntityHelpers } from "../../more/Helpers";
import PepEmploymentRevisionForm from './Employment/PepEmploymentRevisionForm';
import { PEP } from "./PepTypes";
class PepEmploymentAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...


    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;
    private tableFormatterHeadings(originalHeading: string, colName: string) {
        switch (colName) {
            case "break1":
            case "break2":
            case "break3":

                return false;

                break;
            default:
                return false;
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<PEP.EmploymentEntity>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
            case "break1":
            case "break2":
            case "break3":
                let start: Date;
                let end: Date;
                if (colName == "break1") {
                    start = entity.time_break_1_start;
                    end = entity.time_break_1_end;
                }
                else if (colName == "break2") {
                    start = entity.time_break_2_start;
                    end = entity.time_break_2_end;
                }
                else if (colName == "break3") {
                    start = entity.time_break_3_start;
                    end = entity.time_break_3_end;
                }
                else if (colName == "break4") {
                    start = entity.time_break_4_start;
                    end = entity.time_break_4_end;
                }
                else if (colName == "break5") {
                    start = entity.time_break_5_start;
                    end = entity.time_break_5_end;
                }
                

                let content = null;

                
                if (start && end) {
                    if (typeof start == "string") {
                        content = start + " - " + end;
                    } else {
                        // Datum konvertieren
                        content = DateHelpers.dateTimeToString(start, "HH:mm") + " - " + DateHelpers.dateTimeToString(end, "HH:mm");
                    }
                    
                    
                }

                node.innerHTML = content;

                return true;
                break;

           
            default:
                return false;
        }
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
       
    }

    

    private _onClick_Row(row: StaticTable.StaticTableRow<PEP.EmploymentEntity>) {
        this.showEmployment(row.rowGroup.entity);
    }
    

    private showEmployment(data: PEP.EmploymentEntity) {

        let form = new PepEmploymentRevisionForm();
        form.setup(data.ID);

        form.show("dlg", data.gDisp_1);
        form.on("saved", lang.hitch(this, this.reload));
    }

    private startAgenda(hasPrivilege: boolean) {
        if (!hasPrivilege) {
            this.destroy();
            return;
        }

        this.setupAgendaView({
            configCallfunction: "Webtool_API_PEP_EmploymentAgenda__GetAgendaFilterOptionsJSON",
            filterdataCallfunction: "Webtool_API_PEP_EmploymentAgenda__GetAgendaResultListJSON",
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.tableFormatter),
            //initialSelectedDate: new Date()
        });

    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setTableHeadingFormatter(lang.hitch(this, this.tableFormatterHeadings));

        this.hasUserRole("PEP_EmploymentAgenda", lang.hitch(this, this.startAgenda));

        this.setTitles("PEP_EmploymentAgenda__MainTitle");
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PepEmploymentAgenda);